import { $selectedLocation } from "../store/selected/selectedLocations";
import { isPresent } from "../utils";
import i18n from "./i18n";

const onBeforeUnload = (e: BeforeUnloadEvent): string | undefined => {
  const selectedLocation = $selectedLocation.getState();
  if (isPresent(selectedLocation)) {
    e.preventDefault();
    e.returnValue = i18n.t("beforeunload");
    return i18n.t("beforeunload");
  }
};

export const setOnBeforeUnload = (): void => {
  window.addEventListener("beforeunload", onBeforeUnload);
};

export const resetOnBeforeUnload = (): void => {
  window.removeEventListener("beforeunload", onBeforeUnload);
};
